import { useState, useEffect } from 'react'

import { gql, useQuery } from '@apollo/client';

const MARKET_QUERY = gql`
query {
  market(order_by: {name: asc}) {
    id
    name
  }
}
`

export const useMarket = () => {

    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(MARKET_QUERY)
    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.market.reduce((acc, d) => {
                if (d) {
                    acc[d.id] = {
                        'name': d.name,
                    }
                }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

export const useMarketReverse = (upper = false) => {

    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(MARKET_QUERY)
    

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.market.reduce((acc, d) => {
                if (d) {
                    const marketName = upper ? (d.name).toUpperCase() : d.name
                    acc[marketName] = {
                        'id': d.id,
                    }
                }
                return acc
            }, {}))
        }
    }, [data, loading, upper])

    return lookupData
}

/*   
  BITMEX           = 134;
  COINBASE         = 132;
  DERIBIT          = 149;
  GDAX             = 128;

  BINANCE          = 159;
  BINANCE_US       = 160;
  BITFINEX         = 161;
  BITSTAMP         = 162;
  BITTREX          = 163;
  ERISX            = 164;
  FTX              = 165;
  FTX_US           = 166;
  GEMINI           = 167;
  LMAX             = 168;
  OKX              = 169;
  OSL              = 170;
  POLONIEX         = 171;
  ALAMEDA_RESEARCH = 172;
  B2C2             = 173;
  CUMBERLAND       = 174;
  DV_CHAIN         = 175;
  FLOW_TRADERS     = 176;
  GALAXY_DIGITAL   = 177;
  GENESIS          = 178;
  HEHMEYER         = 179;
  JANE_STREET      = 180;
  WINTERMUTE       = 181;
  NZX              = 182;
  CME_DELAYED      = 183;
  KUCOIN           = 184;
  HUOBI            = 185;
 */

export const CRYPTO_MARKETS = [
    "BITMEX", 
    "COINBASE",
    "DERIBIT", 
    "GDAX"
]

export const CRYPTO_MARKET_IDS = [
    128, 132, 134, 149,
]

export const TALOS_MARKETS = [
    "ALAMEDA_RESEARCH",
    "B2C2",
    "BINANCE",
    "BINANCE_US",
    "BITFINEX",
    "BITSTAMP",
    "BITTREX",
    "CME_DELAYED",
    "CUMBERLAND",
    "DV_CHAIN",
    "ERISX",
    "FLOW_TRADERS",
    "FTX",
    "FTX_US",
    "GALAXY_DIGITAL",
    "GEMINI",
    "GENESIS",
    "HEHMEYER",
    "HUOBI",
    "JANE_STREET",
    "KRAKEN",
    "KUCOIN",
    "LMAX",
    "NZX",
    "OKX",
    "OSL",
    "POLONIEX",
    "WINTERMUTE",
]

export const TALOS_MARKET_IDS = [
    133, 159, 160, 161, 162, 163, 164, 
    165, 166, 167, 168, 169, 170, 171, 
    172, 173, 174, 175, 176, 177, 178, 
    179, 180, 181, 182, 183, 184, 185
]

export const TALOS_CLUSTER_MAPPING = {
    // https://github.com/tradingtechnologies/debesys/blob/master/deploy/chef/cookbooks/talos/recipes/talos_ap.rb
    "talos-TALOS-AP" : [
        "KUCOIN",
        "HUOBI",
        "BINANCE",
        "OKX",
        "OSL"
    ],

    // https://github.com/tradingtechnologies/debesys/blob/master/deploy/chef/cookbooks/talos/recipes/talos_eu.rb
    "talos-TALOS-EU" : [
        "BITFINEX",
        "BITSTAMP",
        "LMAX",
        "B2C2"
    ],

    // https://github.com/tradingtechnologies/debesys/blob/master/deploy/chef/cookbooks/talos/recipes/talos_us.rb
    "talos-TALOS-US" : [
        "BINANCE_US",
        "ERISX",
        "GEMINI",
        "KRAKEN",
        "POLONIEX",
        "CUMBERLAND",
        "DV_CHAIN",
        "FLOW_TRADERS",
        "GALAXY_DIGITAL",
        "GENESIS",
        "JANE_STREET",
        "WINTERMUTE"
    ],
}